'use client'

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'

/**
 * Light/dark switch. The choice is the same `extenshi-theme` cookie the
 * cabinet, catalog and blog share (providers.tsx), so a reader's pick carries
 * across every extenshi.io page. `labels` localizes it on end-user pages;
 * each label names the theme the click switches TO.
 */
export function ThemeToggle({ labels }: { labels?: { dark: string; light: string } }) {
	const { resolvedTheme, setTheme } = useTheme()
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) {
		return <Button variant="ghost" size="icon" disabled />
	}

	const isDark = resolvedTheme === 'dark'
	const label = labels ? (isDark ? labels.light : labels.dark) : 'Toggle theme'

	return (
		<Button
			variant="ghost"
			size="icon"
			onClick={() => setTheme(isDark ? 'light' : 'dark')}
			aria-label={label}
			title={labels ? label : undefined}
		>
			{isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
		</Button>
	)
}
